import {
  ConnectBoardState,
  GetMyConnectBoardStateQuery,
} from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const getMyConnectBoardStateHandler =
  graphql.query<GetMyConnectBoardStateQuery>(
    "getMyConnectBoardState",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          me: {
            connectBoardState: ConnectBoardState.Connected,
            // connectBoardState: ConnectBoardState.Invalid,
          },
        },
      });
    }
  );
